import {resolveShopDomain, shopClientApiBase} from '~/utils/shopHost'

/**
 * Resolves the API base for $fetch/useFetch. SSR uses the internal base
 * (the public base is same-origin relative — server fetch can't resolve it —
 * and the public origin sits behind the staging edge basic-auth); the client
 * uses the public same-origin base. On the shop host that base is the shop
 * origin's `/api`, which nginx proxies to Laravel.
 */
export function useApiBaseUrl(): string {
    const config = useRuntimeConfig();
    const configured = (import.meta.server && config.apiBaseUrlServer)
        ? (config.apiBaseUrlServer as string)
        : config.public.apiBaseUrl as string;

    if (import.meta.server) {
        return configured;
    }

    return shopClientApiBase(
        window.location.host,
        resolveShopDomain(config.public.shopDomain as string | undefined, config.public.mainDomain as string | undefined),
        configured,
    );
}

/**
 * API base that the browser can reach, identical on server and client. Needed
 * for URLs that end up in markup or in window.open: the internal SSR base
 * (http://nginx/api/v1) is not resolvable outside the Docker network.
 */
export function usePublicApiBaseUrl(): string {
    return useRuntimeConfig().public.apiBaseUrl;
}
